import { LoginForm } from 'ui/Form/auth/LoginForm';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import { useEffect } from 'react';
import { Spinner } from 'ui';
import { ResendEmail } from 'ui/Modal/ResendEmailModal/ResendEmail';
import { LoginStyleContainer } from './LoginStyleContainer';
import { Modal } from 'antd';
import { useIntl } from 'react-intl';
import PublicRoute from 'enums/publicRoutes';

const PENDING_ERROR_KEY = 'pendingLoginError';

export const Login = () => {
  const { user, isFetchingUser } = useAuth();
  const navigate = useNavigate();
  const intl = useIntl();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');

    if (
      error === 'error.vid_farm_not_found' ||
      error === 'error.registry_unavailable'
    ) {
      sessionStorage.setItem(PENDING_ERROR_KEY, error);
      window.history.replaceState(null, '', window.location.pathname);
      window.location.replace('/vpm/logout');
      return;
    }

    const pendingError = sessionStorage.getItem(PENDING_ERROR_KEY);
    if (pendingError) {
      sessionStorage.removeItem(PENDING_ERROR_KEY);

      const modalConfig = {
        content: intl.formatMessage({ id: pendingError }),
        centered: true,
        closable: true,
        maskClosable: true,
        okText: intl.formatMessage({ id: 'general.close' }),
      };

      if (pendingError === 'message.session_expired') {
        Modal.warning(modalConfig);
      } else {
        Modal.error(modalConfig);
      }
    }
  }, [intl]);

  useEffect(() => {
    if (user?.authenticated && !isFetchingUser) {
      navigate(PublicRoute.HOME);
    }
  }, [user, isFetchingUser, navigate]);

  if (user?.authenticated) return null;

  return (
    <Spinner spinning={isFetchingUser} dontRender>
      <LoginStyleContainer>
        <LoginForm />
        <ResendEmail />
      </LoginStyleContainer>
    </Spinner>
  );
};
